import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { server } from "../../util/server";
import "./Login.css";

function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await axios.post(`${server}/api/user/login`, {
        username,
        password,
      });
      const { token, imovelWebToken } = response.data;
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("imovelWebToken", imovelWebToken);

      toast.success("Login realizado com sucesso!");
      onLogin(true);
      navigate("/");
    } catch (error) {
      toast.error("Usuário ou senha incorretos");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-background-overlay"></div>
      <div className="login-content-wrapper">
        <div className="login-card">
          <div className="login-card-header">
            <div className="login-logo-container">
              <img
                className="login-logo"
                alt="Logo Imóveis Vende"
                src="/logo-not.png"
              />
            </div>
            <h1 className="login-title">Bem-vindo</h1>
            <p className="login-subtitle">Faça login para acessar o painel</p>
          </div>
          <form onSubmit={handleLogin} className="login-form">
            <div className="login-form-group">
              <label htmlFor="username" className="login-label">
                Usuário
              </label>
              <input
                type="text"
                className="login-input"
                id="username"
                placeholder="Digite seu usuário"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                disabled={isLoading}
                autoComplete="username"
              />
            </div>
            <div className="login-form-group">
              <label htmlFor="password" className="login-label">
                Senha
              </label>
              <input
                type="password"
                className="login-input"
                id="password"
                placeholder="Digite sua senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={isLoading}
                autoComplete="current-password"
              />
            </div>
            <button
              className="login-button"
              type="submit"
              disabled={isLoading || !username || !password}
            >
              {isLoading ? (
                <>
                  <span className="login-spinner"></span>
                  Entrando...
                </>
              ) : (
                "Entrar"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;